import { App, defineCustomElement } from 'vue'
import { createPinia } from 'pinia'

import 'floating-vue/dist/style.css'

import MainApp from './App.vue'

const pinia = createPinia();

const customApp = (app: App) => {
  app.use(pinia);
};

// declare as custom element
const element = defineCustomElement(MainApp, { configureApp: customApp, shadowRoot: false });
customElements.define('mf-materials', element)
